import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

// Generate or get user ID from localStorage
export function getUserId() {
    let userId = localStorage.getItem('iulian_ai_user_id');
    if (!userId) {
        userId = 'user_' + Math.random().toString(36).substring(2, 15);
        localStorage.setItem('iulian_ai_user_id', userId);
    }
    return userId;
}

// Format date for display
export function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString('ro-RO', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    });
}

// Format time for display
export function formatTime(dateString) {
    const date = new Date(dateString);
    return date.toLocaleTimeString('ro-RO', {
        hour: '2-digit',
        minute: '2-digit'
    });
}

// Format relative time
export function formatRelativeTime(dateString) {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);
    
    if (diffInSeconds < 60) return 'Acum';
    if (diffInSeconds < 3600) return `acum ${Math.floor(diffInSeconds / 60)} min`;
    if (diffInSeconds < 86400) return `acum ${Math.floor(diffInSeconds / 3600)} ore`;
    if (diffInSeconds < 604800) return `acum ${Math.floor(diffInSeconds / 86400)} zile`;
    
    return formatDate(dateString);
}

// Category info
export const CATEGORIES = {
    traume: {
        id: 'traume',
        name: 'Traume',
        description: 'Ghidare pentru procesarea experiențelor dificile',
        icon: 'Heart',
        color: 'emerald'
    },
    educatie: {
        id: 'educatie',
        name: 'Educație',
        description: 'Suport pentru dificultăți de învățare și dezvoltare',
        icon: 'BookOpen',
        color: 'emerald'
    },
    emotii: {
        id: 'emotii',
        name: 'Emoții',
        description: 'Tehnici pentru gestionarea emoțiilor',
        icon: 'Sparkles',
        color: 'emerald'
    }
};

// Mood options
export const MOODS = [
    { id: 'calm', label: 'Calm', emoji: '😌' },
    { id: 'happy', label: 'Fericit', emoji: '😊' },
    { id: 'neutral', label: 'Neutru', emoji: '😐' },
    { id: 'anxious', label: 'Anxios', emoji: '😰' },
    { id: 'sad', label: 'Trist', emoji: '😢' }
];
